// extracted by mini-css-extract-plugin
export default {"centered":"ActivationExpired_centered__qb9gy","centeredText":"ActivationExpired_centeredText__8pkgE"};